import React, { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbContext = createContext(null);

/**
 * Provider à placer dans App.js (à l'intérieur du BrowserRouter).
 * Permet aux pages de surcharger le label du dernier segment du breadcrumb.
 */
export const BreadcrumbProvider = ({ children }) => {
  const [pageTitle, setPageTitleState] = useState(null);

  const setPageTitle = useCallback((title) => {
    setPageTitleState(title || null);
  }, []);

  const clearPageTitle = useCallback(() => {
    setPageTitleState(null);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ pageTitle, setPageTitle, clearPageTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

/**
 * Hook pour les pages qui veulent afficher un label dynamique.
 *
 * Usage dans une page :
 *   const { setPageTitle } = useBreadcrumbTitle();
 *   useEffect(() => {
 *     if (contrat?.numeroPolice) setPageTitle(contrat.numeroPolice);
 *     return () => setPageTitle(null); // nettoyage au démontage
 *   }, [contrat]);
 */
export const useBreadcrumbTitle = () => {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) throw new Error("useBreadcrumbTitle must be used inside BreadcrumbProvider");
  return ctx;
};

export default BreadcrumbContext;
